<app-dialog [show]="show" [size]="'md'" [position]="'center'" [showHeader]="showHeader" [title]="'Confirm Email Notification Resend'" (close)="onCancel()">
  <div class="flex flex-col items-center justify-center min-h-[350px] w-full px-4 py-6">
    <div class="flex flex-col w-full max-w-md">
      <div class="flex items-center mb-4">
        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 mr-4">
          <i class="pi pi-envelope text-2xl text-gray-400"></i>
        </div>
        <div>
          <div class="font-semibold text-base sm:text-lg">Verification Email</div>
          <div class="text-gray-600 text-sm">Send a new verification email to the party</div>
        </div>
      </div>

      <div class="flex items-start w-full bg-gray-100 rounded-lg mb-4">
        <app-alert-message [type]="'info'" [bordered]="true">
        <p class="text-gray-600 text-sm font-normal leading-normal font-['Inter']">This will send a new email notification to <span class="font-semibold">{{ recipientName }}</span> with instructions to complete their identity verification. </p>
      </app-alert-message>
      </div>
      
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-700 mb-1">File Number</label>
        <input type="text" class="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100 text-gray-700" [value]="fileNumber" readonly />
      </div>
      <div class="flex justify-end w-full gap-2">
        <button type="button" (click)="onCancel()"
          class="h-10 w-24 rounded-lg bg-gray-100 hover:bg-gray-200 text-sm text-gray-700 transition-colors cursor-pointer">
          Cancel
        </button>
        <button type="button" (click)="onConfirm()"
          class="h-10 w-32 rounded-lg bg-black text-white hover:bg-gray-800 text-sm transition-colors duration-200 flex items-center justify-center gap-2 cursor-pointer">
          <i class="pi pi-send"></i> Send Email
        </button>
      </div>
    </div>
  </div>
</app-dialog> 